import RestService from '@/modules/backend/RestService';
import { AccountsOfBuildingReportInterface, AccountsReportResultInterface } from '@/modules/backend';

export default class Reports {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async MonthlyReport(payload: AccountsOfBuildingReportInterface): Promise<AccountsReportResultInterface> {
    return await this.rest.get(`/api/v1/report/${payload.BuildingId}`, {
      params: {
        to: payload.To,
        from: payload.From
      }
    });
  }
}
